<template>
    <div>
        <div id="RecuperacionDeContrasena_div" class="w-100 px-5 py-4">
            <div id="TituloRecuperacionDeContrasena_div">
                <h1>ACTUALIZAR CONTRASEÑAS DE MAJAT</h1>
                <h3>Encargado de actualizar la contraseñas de Majat con la de Themis</h3>
            </div>
            <div class="d-flex row">
                <div class="col-12 col-sm-12 col-md-12 col-lg-3 col-xl-3 padding-div-low">
                    <div class="area">
                        <h2>Condiciones</h2>
                        <hr />
                        <div class="form-group">
                            <h6>Tipo de actualización</h6>
                            <select id="tipoActualizacion_Select" class="form-control" v-model="informacionDeLaSubventana.tipoActualizacionId" v-on:change="ActualizaLasVentanas()">
                                <option v-for="tipoActualizacion in tiposActualizacion" :key="tipoActualizacion.Key" :value="tipoActualizacion.Key">{{tipoActualizacion.Value}}</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div v-if="informacionDeLaSubventana.mostrar == true" class="col-12 col-sm-12 col-md-12 col-lg-9 col-xl-9 padding-div-low">
                    <div class="area">
                        <h3>MAJAT</h3>
                        <h6>{{informacionDeLaSubventana.subtitulo}}</h6>
                        <hr />
                        <div class="text-justify">
                            <h6 v-html="informacionDeLaSubventana.informacion"></h6>
                            <br />
                            <div class="col-12 text-center">
                                <button class="btn btn-warning overwrapDeBotones" id="enviarCorreo" v-on:click="ActualizarLasContraseñas()"><i class="fas fa-sync-alt"></i>&nbsp;&nbsp;Proceder y actualizar las contraseñas</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import enumeraciones from '@/../static/js/enumeraciones'
import comun from '@/../static/js/comun'
import api from '@/../static/js/api'
import axios from 'axios'

export default {
    data() {
        return {
            enumeraciones, 
            comun,
            tiposActualizacion: [
                { Key: -1, Value: "Seleccione una opción" },
                { Key: 0, Value: "Todos" },
                { Key: 1, Value: "Solo activos" },
                { Key: 2, Value: "Solo con contraseña diferente" },
            ],
            informacionDeLaSubventana: {
                subtitulo: "", 
                mostrar: false, 
                informacion: "", 
                tipoActualizacionId: -1
            }
        }
    }, 
    methods: {
        ActualizaLasVentanas: function() {
            switch(parseInt(this.informacionDeLaSubventana.tipoActualizacionId)) {
                case -1:
                    this.informacionDeLaSubventana.subtitulo = "";
                    this.informacionDeLaSubventana.mostrar = false;
                    this.informacionDeLaSubventana.informacion = "";
                    break;
                case 0:
                    this.informacionDeLaSubventana.subtitulo = "Actualización de todas las contraseñas.";
                    this.informacionDeLaSubventana.mostrar = true;
                    this.informacionDeLaSubventana.informacion = "Una vez que presione el boton, el sistema de Themis procedera a actualizar TODAS las contraseñas del sistema de Majat, para que sean identicas al mismo.<br /><br />Si desea proceder, presione el boton para actualizar las contraseñas de Majat.";
                    break;
                case 1:
                    this.informacionDeLaSubventana.subtitulo = "Actualización de las contraseñas de solo usuarios activos.";
                    this.informacionDeLaSubventana.mostrar = true;
                    this.informacionDeLaSubventana.informacion = "Una vez que presione el boton, el sistema de Themis procedera a actualizar TODAS las contraseñas del sistema de Majat de los usuarios que esten ACTIVOS, para que sean identicas al mismo.<br /><br />Si desea proceder, presione el boton para actualizar las contraseñas de Majat.";
                    break;
                case 2:
                    this.informacionDeLaSubventana.subtitulo = "Actualización de las contraseñas de solo usuarios con contraseña diferente.";
                    this.informacionDeLaSubventana.mostrar = true;
                    this.informacionDeLaSubventana.informacion = "Una vez que presione el boton, el sistema de Themis procedera a actualizar TODAS las contraseñas que sean diferentes entre este sistema y el de Majat, dando prioridad a las contraseñas de Themis.<br /><br />Si desea proceder, presione el boton para actualizar las contraseñas de Majat.";
                    break;
            }
        }, 
        ActualizarLasContraseñas: function() {
            let parametros = {
                TipoActualizacionId: this.informacionDeLaSubventana.tipoActualizacionId,
                EsPrueba: this.enumeraciones.EsPrueba
            }

            comun.SeEstaCargandoInformacion(true);

            axios.post(
                api.conexion + api.SICUS.sistema.administracion.actualizarContrasenasDeMajat.ActualizarContrasenas,
                parametros,
                comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal))
            .then(respuesta => {
                if (respuesta.data.SiHayError) {
                    console.log(respuesta);
                    comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                    this.$store.dispatch('A_ReglasDeRuteo', { aDondeSeRuteaOElError: respuesta.data.Error.MensajeId });
                } else {
                    this.informacionDeLaSubventana.subtitulo = "";
                    this.informacionDeLaSubventana.mostrar = false;
                    this.informacionDeLaSubventana.informacion = "";
                    this.informacionDeLaSubventana.tipoActualizacionId = -1;

                    comun.mensajeDeAlerta(respuesta.data.Satisfactorio);
                }

                comun.SeEstaCargandoInformacion(false);
            })
            .catch(excepcion => {
                console.log(excepcion);
                comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null)
                comun.SeEstaCargandoInformacion(false);
            });
        }
    }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/SICUS/Administracion/ActualizarContrasenasDeMajat/Index.vue